<div class="section">
    <div class="nova__label">Years of Experience Required</div>
    <div data-qa-id="an_rjd_locums_exp_yrs_readonly">
        {{ (jobUnitDetails$ | async)?.yearOfExperience | nullDash }}
    </div>

    <div class="nova__label">Charting Experience</div>
    <div data-qa-id="an_rjd_locums_exp_charting_value">
        <label *ngIf="!showUDExperience" data-qa-id="an_rjd_locums_exp_charting_empty">-</label>
        <div class="jd__section__container" *ngIf="showUDExperience">
            <label data-qa-id="an_rjd_locums_exp_charting_type">
                {{ (jobUnitDetails$ | async)?.chartingType | nullDash }}
            </label>
            <label class="jd__section__emphasized" data-qa-id="an_rjd_locums_exp_charting_readonly">
                {{ locumsUtility.translateExperience((jobUnitDetails$ | async)?.chartingExperience) }}
            </label>
        </div>
    </div>    
    
    <div class="nova__label">Teaching Hospital Experience</div>
    <div data-qa-id="an_rjd_locums_exp_teaching_hosp_readonly">
        {{ (locumsUtility.translateExperience((jobUnitDetails$ | async)?.teachingHospitalExperience)) | nullDash }}
    </div>

    <div class="nova__label">Trauma Level I Experience</div>
    <div data-qa-id="an_rjd_locums_exp_trauma_lvl1_readonly">
        {{ (locumsUtility.translateExperience((jobUnitDetails$ | async)?.traumaLevelIExperience)) | nullDash }}
    </div>

    <div class="nova__label">Trauma Level II Experience</div>
    <div data-qa-id="an_rjd_locums_exp_trauma_lvl2_readonly">
        {{ (locumsUtility.translateExperience((jobUnitDetails$ | async)?.traumaLevelIIExperience)) | nullDash }}
    </div>
</div>